<div class="ng-banks"
     (clickOutside)="onClickedOutside()"
     [excludeBeforeClick]="true"
     [exclude]="'.ng-credit-price'">
    <div *ngFor="let creditTerm of creditTerms"
         class="ng-bank showHotelInfo"
         data-target-tab="tabCredit"
         [attr.data-credit-provider-id]="creditTerm.id"
    >
        <div class="ng-img">
            <img [attr.src]="getLogoSrc(creditTerm)">
        </div>
        <div class="ng-term">
            <p>Купить в кредит:</p>
            <p>
                <span class="ng-price">{{ getPrice(creditTerm) | priceFormat }}</span> на {{ creditTerm.months }} мес.
            </p>
        </div>
        <div class="ng-arrow-container">
            <div class="ng-arrow"></div>
        </div>
    </div>
</div>
